import { useAtomValue, useSetAtom } from 'jotai';

import { Stack } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';
import {
	FiltersDrawerCheckboxGroup,
	type FiltersDrawerCheckboxGroupItem,
} from '@common/components/FilterGroups/FiltersDrawerCheckboxGroup';

import { updateVehicleModelsFilterAtom,vehicleModelsFilterAtom } from '../../atoms/leadsAtoms';
import { useLeadsFacetCounts } from '../../hooks/useLeadsFacetCounts';

/**
 * FiltersDrawerVehicleInterestsSection component that provides vehicle interests filtering options
 * wrapped in an accordion
 *
 * Note: The models field is an array in LeadSearchRecord. Algolia should support faceting on array fields,
 * but if issues arise, consider denormalizing the data during indexing.
 */
export function FiltersDrawerVehicleInterestsSection() {
	const vehicleModels = useAtomValue(vehicleModelsFilterAtom);
	const setVehicleModels = useSetAtom(updateVehicleModelsFilterAtom);

	// Get dynamic facet counts from the search response
	const { modelCounts } = useLeadsFacetCounts();

	// Build vehicle model items with dynamic counts
	const vehicleItems: FiltersDrawerCheckboxGroupItem[] = Object.keys(modelCounts)
		.sort()
		.map((model) => ({
			value: model,
			label: model,
			count: modelCounts[model] ?? 0,
		}));

	// Determine if this section has any applied filters
	const hasAppliedFilters = vehicleModels.length > 0;

	return (
		<AccordionSection title='Vehicle interests' defaultExpanded={hasAppliedFilters}>
			<Stack itemsSpacing='24'>
				<FiltersDrawerCheckboxGroup
					label='Model names'
					items={vehicleItems}
					value={vehicleModels}
					onChange={setVehicleModels}
				/>
			</Stack>
		</AccordionSection>
	);
}
